import {
  fetchByCompany,
  fetchFiltered,
  addOrigin,
  show,
  edit
} from '@/api/origin'

const state = {
  all: [],
  isLoading: false,
  originById: null
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const origin = await show(id)
      commit('setOriginById', origin)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchByCompany ({ dispatch, commit }, company) {
    try {
      dispatch('overlay/show', true, { root: true })

      const origins = await fetchByCompany(company)
      commit('setAll', origins)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const origins = await fetchFiltered(queriesParams)
      commit('setAll', origins.rows)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  // async create ({ dispatch, commit }, data) {
  //   commit('setLoading', true)
  //   try {
  //     await addOrigin(data)
  //     return true
  //   } catch (e) {
  //     dispatch('notify/error', e, { root: true })
  //   } finally {
  //     commit('setLoading', false)
  //   }
  //   return false
  // },

  // async edit ({ dispatch, commit }, { id, data }) {
  //   commit('setLoading', true)
  //   try {
  //     await edit(id, data)
  //     return true
  //   } catch (e) {
  //     dispatch('notify/error', e, { root: true })
  //   } finally {
  //     commit('setLoading', false)
  //   }
  //   return false
  // }
}

const mutations = {
  cleanState (state) {
    state.all = []
    state.isLoading = false
    state.originById = null
  },

  setAll (state, origin) {
    state.all = origin
  },

  setOriginById (state, origin) {
    state.originById = origin
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
